import React, { Fragment, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Popconfirm, Tooltip } from 'antd';
import { CopyOutlined, InfoCircleOutlined } from '@ant-design/icons';

import BillingDocumentModal from './../BillingDocumentModal';
import promptLogo from '../../../../../img/prompt-logo.png';
import setNotification from '../../../../../utils/setNotification.utils';

const BillingCard = ({
  date,
  status,
  bill_id,
  bill_number,
  bill_date,
  billed_by,
  currentPeriod,
  getBillingDocument,
  billingDocument,
  refreshBillingList,
  visibleProfile
}) => {
  const [openBillingDocument, setOpenBillingDocument] = useState(false);
  const [fromPopup, setFromPopup] = useState(false);

  const openBillingDocumentModal = () => {
    setOpenBillingDocument(true);
    getBillingDocument();
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(bill_id);
    setNotification('success', 'Success!', 'Copied to clipboard.', 2);
  };

  return (
    <Fragment>
      <BillingDocumentModal
        openBillingDocument={openBillingDocument}
        setOpenBillingDocument={setOpenBillingDocument}
        billingDocumentDetails={billingDocument}
        date={date}
        bill_number={bill_number}
        fromPopup={fromPopup}
        refreshBillingList={updated => refreshBillingList(updated)}
      />
      <div className="patient-detail-tab-billing-card-container">
        <div className="patient-detail-tab-billing-card-header">
          <div className="patient-detail-tab-billing-card-date-container">
            <span className="patient-detail-tab-billing-card-time">
              {' '}
              {date}{' '}
            </span>
            {status === 'marked' && (
              <div className="patient-detail-tab-billing-card-status-container marked-card">
                <div className="patient-detail-tab-billing-card-status-dot marked-dot" />
                <span> Mark as Billed</span>
              </div>
            )}
            {status === 'billed' && (
              <div className="patient-detail-tab-billing-card-status-container billed-card">
                <div className="patient-detail-tab-billing-card-status-dot billed-dot" />
                <span> Billed</span>

                {bill_date && (
                  <Tooltip
                    overlayInnerStyle={{ width: 'max-content' }}
                    title={`${new Date(bill_date).toLocaleDateString('en-US', {
                      dateStyle: 'long'
                    })}${billed_by ? ` by ${billed_by}` : ''}`}
                  >
                    <div style={{ marginLeft: 8 }}>
                      <InfoCircleOutlined />
                    </div>
                  </Tooltip>
                )}
              </div>
            )}
          </div>

          {status === 'billed' ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {!!visibleProfile?.GroupInfo?.EnablePrompt && (
                <Tooltip title="Get Code to Export in Prompt">
                  <img
                    alt="prompt-logo"
                    src={promptLogo}
                    onClick={copyToClipboard}
                    style={{
                      cursor: 'pointer',
                      width: 'auto',
                      height: '1.5em'
                    }}
                  />
                </Tooltip>
              )}

              <div
                className="patient-detail-tab-billing-card-body-copy-icon"
                onClick={openBillingDocumentModal}
              >
                <div
                  className={`patient-detail-tab-billing-card-body-item ${
                    !currentPeriod ? '' : 'current-period'
                  }`}
                >
                  <span className="patient-detail-tab-billing-card-body-item-text">
                    {bill_number}
                  </span>
                  <CopyOutlined />
                </div>
              </div>
            </div>
          ) : (
            <Popconfirm
              title={
                <p>
                  Accessing this documentation will mark this code as Billed in
                  the system
                  <br />
                  and may trigger an account charge based on your subscription
                  agreement.
                  <br />
                  Would you like to continue?
                </p>
              }
              placement="topRight"
              okText="Yes"
              cancelText="No"
              onConfirm={() => {
                openBillingDocumentModal();
                setFromPopup(true);
              }}
            >
              <div className="patient-detail-tab-billing-card-body-copy-icon">
                <div
                  className={`patient-detail-tab-billing-card-body-item ${
                    !currentPeriod ? '' : 'current-period'
                  }`}
                >
                  <span className="patient-detail-tab-billing-card-body-item-text">
                    {bill_number}
                  </span>
                  <CopyOutlined />
                </div>
              </div>
            </Popconfirm>
          )}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  visibleProfile: state.visibleProfile
});

export default withRouter(connect(mapStateToProps)(BillingCard));
